<script lang="ts">
// IT-3580
import { defineStore } from 'pinia'

export const useMultiDownload = defineStore('multiDownload', {
  state: () => ({
    countComplete: 0 as number,
    countTotal: 0 as number,
    isDownloading: false as boolean,
  }),
})
</script>
<script setup lang="ts">
// from MybookDownload.vue
import ProgressBar from 'primevue/progressbar'

const downloadState = useMultiDownload()
const progressPercentage = computed(() => {
  return (
    Math.floor(
      (downloadState.countComplete / downloadState.countTotal) * 100,
    ) || 1
  )
})
</script>
<!-- https://www.figma.com/file/3KXNZFMGZqMrYjnq00pJFB/Genoplan-Portal-(%EB%B3%91%EC%9B%90%EC%9A%A9-%EC%96%B4%EB%93%9C%EB%AF%BC)?type=design&node-id=1658-15979&mode=dev -->
<template>
  <Toast position="bottom-right" group="headless" style="opacity: 1">
    <template #container>
      <section class="flex p-4 gap-2 w-full bg-white rounded-md shadow">
        <i class="pi pi-download text-16 text-verdigris-500" />
        <div class="flex flex-col gap-6 w-full">
          <p class="m-0 text-14 font-medium text-grey-700">
            다운로드 준비중입니다.
          </p>
          <div class="flex flex-col gap-1">
            <ProgressBar
              :value="progressPercentage"
              :showValue="false"
              :style="{ height: '6px' }"
            />
            <label class="text-right text-12 text-grey-400">
              {{ progressPercentage }}%
            </label>
          </div>
        </div>
      </section>
    </template>
  </Toast>
</template>
